module.exports = __webpack_public_path__ + "static/sofia-001-61dde519fcc9910f5bd7cb7baeebe08f.jpg";